export default [
  {
    path: '/advertisements/splash-screen',
    name: 'splash-screen-list',
    component: () => import('@/views/marketing/splash-screen/pages/SplashScreenList.vue'),
    meta: {
      resource: 'splash-screen',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Splash Screen',
    },
  },
  {
    path: '/advertisements/list',
    name: 'advertisements-list',
    component: () => import('@/views/marketing/advertisements/pages/AdsList.vue'),
    meta: {
      resource: 'advertisement',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Advertisement',
    },
  },
  {
    path: '/advertisements/create-new',
    name: 'advertisements-create-new',
    component: () => import('@/views/marketing/advertisements/pages/CreateAd.vue'),
    meta: {
      resource: 'advertisement',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Advertisement',
      breadcrumb: [
        {
          text: 'Advertisements',
          to: '/advertisements/list',
        },
      ],
    },
  },
]
